import queryString from "query-string";
import ApiService from "./ApiService";

export async function apiGetCurrentContracts(params = {}) {
  return ApiService.fetchData({
    url: `Contract/Current?${queryString.stringify(params, { skipNull: true })}`,
    method: "get",
    skipErrorHandler: true,
  });
}

export async function apiGetPendingContracts(params = {}) {
  return ApiService.fetchData({
    url: `Contract/Pending?${queryString.stringify(params, { skipNull: true })}`,
    method: "get",
    skipErrorHandler: true,
  });
}

export async function apiApproveContract(contractversionid) {
  return ApiService.fetchData({
    url: "Contract/Approve",
    method: "post",
    data: { contractversionid },
    skipErrorHandler: true,
  });
}

export async function apiGetContractVersions(params = {}) {
  return ApiService.fetchData({
    url: `Contract/Versions?${queryString.stringify(params, { skipNull: true })}`,
    method: "get",
  });
}

export async function apiUploadContract(data) {
  return ApiService.fetchData({
    url: "Contract/Upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

export async function apiDeleteContract(id) {
  return ApiService.fetchData({
    url: `Contract/Delete?id=${id}`,
    method: "delete",
  });
}
